import { useRouter } from 'next/router';
import { Col, Grid, Image, Row, Typography } from 'antd';
import { ButtonBorderKomunitasBeranda, ButtonBorderKomunitasDetailArtikel } from 'src/components/Forms/Button';
import classes from './indexweb.module.less';
const JoinKomunitasDetailArtikelContainerWeb = (props: any) => {
  const {
    xs
  } = Grid.useBreakpoint();
  const router = useRouter();
  const typeArtikel = props.artikel.type;
  return <div className={classes['page-body-wrap']}>
			<div className="container">
				<Row>
					<Col md={24} sm={24} xs={24} lg={17} xl={17}>
						<div className="container">
							<div className={typeArtikel === 'pre-pregnancy' ? classes.pageheropre : typeArtikel === 'pregnancy' ? classes.pagehero : classes.pageheropost}>
								<Row>
									<Col md={17} sm={{
                  span: 17,
                  order: 1
                }} xs={{
                  span: 24,
                  order: 1
                }} lg={17} xl={17} style={{
                  alignContent: 'center',
                  justifyContent: 'center'
                }}>
										{typeArtikel === 'pre-pregnancy' ? <div style={{
                    marginLeft: xs ? '20px' : '10px',
                    marginRight: '20px'
                  }}>
												<p className={classes.title1}>
													Saling Dukung dan Berbagi Cerita di Komunitas Program Hamil
												</p>
												<Typography className={classes.paragraph1}>
													Gabung komunitas Hallobumil dan temukan support, edukasi dan inspirasi di setiap
													langkah perjuanganmu
												</Typography>
												<div onClick={() => router.push('/komunitas')} style={{
                      marginTop: '10px',
                      marginBottom: '40px',
                      marginLeft: '20px'
                    }}>
													<ButtonBorderKomunitasDetailArtikel text={'Gabung Komunitas Program Hamil'} size='large'></ButtonBorderKomunitasDetailArtikel>
												</div>

											</div> : typeArtikel === 'pregnancy' ? <div style={{
                    marginLeft: xs ? '20px' : '40px',
                    marginRight: '20px',
                    marginTop: '20px'
                  }}>
												<p className={classes.title}>
													Nikmati Perjalanan Kehamilan Bersama Bumil Lainnya
												</p>
												<Typography className={classes.paragraph}>
													Gabung dan temui teman, tips, dan cerita inspiratif di komunitas Hallobumil
													untuk lewati masa hamil dengan penuh dukungan
												</Typography>
												<div onClick={() => router.push('/komunitas')} style={{
                      marginTop: '10px',
                      marginBottom: '40px',
                      marginLeft: '0px'
                    }}>
													<ButtonBorderKomunitasBeranda text={'Gabung Komunitas Kehamilan'} size='large'></ButtonBorderKomunitasBeranda>
												</div>
											</div> : <div style={{
                    marginLeft: xs ? '20px' : '20px',
                    marginRight: '20px'
                  }}>
												<p className={classes.title1}>Tumbuh Bersama di 1000 Hari Pertama Si Kecil</p>
												<Typography className={classes.paragraph1}>
													Komunitas hangat untuk dapatkan tips, cerita inspiratif, dan teman baru pada
													1000 hari pertama si kecil bersama Hallobumil
												</Typography>
												<div onClick={() => router.push('/komunitas')} style={{
                      marginTop: '10px',
                      marginBottom: '40px',
                      marginLeft: '20px'
                    }}>
													<ButtonBorderKomunitasDetailArtikel text={'Gabung Komunitas Tumbuh Kembang'} size='large'></ButtonBorderKomunitasDetailArtikel>
												</div>
											</div>}
									</Col>
									<Col md={7} sm={{
                  span: 7,
                  order: 2
                }} xs={{
                  span: 24,
                  order: 2
                }} lg={7} xl={7} style={{
                  textAlign: 'center',
                  alignContent: 'center',
                  justifyContent: 'center'
                }}>
										<div style={{
                    textAlign: 'left',
                    alignContent: 'center',
                    justifyContent: 'center',
                    // marginLeft: '10px',
                    marginRight: '24px'
                  }}>
											{typeArtikel === 'pre-pregnancy' ? <Image src="/images/default/prepregnancy.svg" alt="image" preview={false} width={200} height={150} /> : typeArtikel === 'pregnancy' ? <Image src="/images/default/pregnancy.svg" alt="image" preview={false} width={200} height={150} /> : <Image src="/images/default/postpregnancy.svg" alt="image" preview={false} width={200} height={150} />}
										</div>
									</Col>
								</Row>
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</div>;
};
export default JoinKomunitasDetailArtikelContainerWeb;